export const LogoMark = ({ size = 36, dark = false }) => {
  const ring = dark ? "#FFFFFF" : "#0C1F2C";
  const house = dark ? "#2FA98A" : "#147D64";
  return (
    <svg
      viewBox="0 0 240 240"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M 52.5 159.0 A 78 78 0 1 1 187.5 159.0"
        fill="none"
        stroke={ring}
        strokeWidth="15"
        strokeLinecap="round"
      />
      <g fill={ring}>
        <circle cx="175.2" cy="175.2" r="7" />
        <circle cx="159.0" cy="187.5" r="7" />
        <circle cx="140.2" cy="195.3" r="7" />
        <circle cx="120.0" cy="198.0" r="7" />
        <circle cx="99.8" cy="195.3" r="7" />
        <circle cx="81.0" cy="187.5" r="7" />
        <circle cx="64.8" cy="175.2" r="7" />
      </g>
      <path
        d="M 90 129 L 120 101 L 150 129 L 150 161 L 90 161 Z"
        fill="none"
        stroke={house}
        strokeWidth="10"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx="120" cy="141" r="8" fill="#E8C77E" />
    </svg>
  );
};

export const Wordmark = ({ dark = false, className = "" }) => (
  <span className={`font-display font-extrabold tracking-tight ${className}`}>
    <span className={dark ? "text-white" : "text-ink"}>mort</span>
    <span className={dark ? "text-lens-bright" : "text-lens"}>lens</span>
  </span>
);
